import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-calendar', 'weekDays', [
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa',
    'Su',
]);
Labels.set('ui-calendar', 'weekDaysLong', [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
]);
Labels.set('ui-calendar', 'prevMonth', 'Previous month');
Labels.set('ui-calendar', 'nextMonth', 'Next month');
Labels.set('ui-calendar', 'arrowKeys', 'Arrow keys can navigate dates');
